'use strict';
// manage Ajax requests
Fotobook.core = {
    /**
     * URL по которому доступны проекты пользователя
     */
    projectsViewURL: '/projects',

    /**
     * Обновить список альбомов проекта
     */
    updateAlbumsList() {
        Fotobook.ajax.postJSON('/editor/get-albums-list').then((response) => {
            Fotobook.book.setAlbums(response.data.albums);
            Fotobook.bottomPanel.fotosTab.markFotocollection();
            Fotobook.fotoManager.getTotalCountFotos();
        });
    },

    getAlbumFotos(params) {
        params = params || {};

        const promise = Fotobook.ajax.postJSON('/photos/get-album-photos', {
            data: params,
        }).then((response) => {
            response = response.data;
            Fotobook.bottomPanel.fotosTab.checkHideUsedVisibility();
            Fotobook.fotoManager.imagesTab.setFolders(response.folders);
            Fotobook.fotoManager.imagesTab.setImages(response.fotos);

            // отрисовка фотоколлекции
            Fotobook.store.dispatch('imagesPanel/draw');

            Fotobook.bottomPanel.fotosTab.markFotocollection();

            // Убираем возможные последствия потерянного draggable из-за перерисовки фото в нижней панели
            // (если в момент переисовки производился drag фото)
            // ????
            // --> подтвержить актуальность данного кода не удалось, existFotoDraggable.length === 0
            // const existFotoDraggable = $('.album_image.ui-draggable-dragging');
            // if (existFotoDraggable.length) {
            //     existFotoDraggable.remove();
            //     $(Fotobook.book.book).removeClass('image-drag');
            // }
            // ??
            $('.qtip').hide();
        });
        promise.catch(() => null);
        return promise;
    },

    /**
     * Сохранить проект
     * @returns {*}
     */
    saveProject(asyncPreview = true) {
        return Fotobook.ajax.postJSON('/editor/project/save', {
            data: {
                async: asyncPreview ? 1 : 0,
            },
        }).then((response) => {
            Fotobook.isModified = false;
            if (response.data.state) {
                Fotobook.book.initState(response.data);
            }
            return response;
        });
    },
};
